import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { UserService } from 'src/app/service/user.service';
import { regexValidators } from 'src/app/validation/validator';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  rotate: any;
  users: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  deleteID: any;
  isLoading: boolean;
  userForm: any;
  roles: any;
  location: any;
  updateID: any;


  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {

    this.userForm = this.formBuilder.group({
      user: ["", [Validators.required]],
      name: ["", [Validators.required]],
      email: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      password: ['', Validators.compose([Validators.pattern(regexValidators.password),
        Validators.required])],
      confirmPassword: ['', Validators.compose([
        Validators.pattern(regexValidators.password),
        Validators.required,
        this.equalto('password'),
      ])],
    }, {validator: this.checkPasswords});


  }

  ngOnInit() {
    this.getAllUsers();
    // this.getallRoles();
    // this.getallLocations();
  }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value;

    return pass === confirmPass ? null : {notSame: true};
  }

  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

      let input = control.value;

      let isValid = control.root.value[field_name] == input;
      if (!isValid) {
        return {'equalTo': {isValid}};
      } else {
        return null;
      }
    };
  }


  getAllUsers() {
    this.userService.getallusers().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.users = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  userUpdate(user) {
    this.updateID =user.id;
    this.addModal.show();
    this.userForm.controls['user'].setValue(user.username);
    this.userForm.controls['email'].setValue(user.email);
    this.userForm.controls['mobile'].setValue(user.mobileNo);
    this.userForm.controls['role'].setValue(user.role.id);
    this.userForm.controls['locations'].setValue(user.locationList);
    this.userForm.controls['password'].setValue(user.mobileNo);

  }



  // ============================USER DELETE =====================================

  userDelete(template, id) {
    this.deleteID = id;
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  declineDelete() {
    // this.message = 'You clicked the 'decline' action!';
    this.modalRef.hide();
  }

  confirmDelete() {
    this.deleteUser();
  }

  deleteUser() {
    this.userService.deleteUser(this.deleteID).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
          this.getAllUsers();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  // ============================USER CREATE =====================================
  cars: any;


  createModal() {
    this.addModal.show();
  }


  createUser() {
    this.isLoading = true;
    let req = {
      email: this.userForm.controls.email.value,
      fulName: this.userForm.controls.name.value,
      id: 0,
      mobileNo: this.userForm.controls.mobile.value,
      password: this.userForm.controls.confirmPassword.value,
      username: this.userForm.controls.user.value,
    }

    this.userService.newUser(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.addModal.hide();
          this.isLoading = false;
          this.notifier.notify('success', res.responseDesc);
          this.getAllUsers();
        } else {
          this.isLoading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }


  userActive(id: any) {
    this.userService.activeUser(id).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.notifier.notify('success', res.responseDesc);
          this.getAllUsers();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
